import Emitter from "./Emitter";

export default class OpenHelp extends Emitter {
    constructor(gb) {
        super(gb);
    }

    ENDOR_handler(){
        this.emitGame({messageId: "toggleHelp", action: "show" })
    }

    _default() {
        this.emitGame({ wpgaction: "openHelp" });
    }
}
